import * as React from 'react';

export const TreeItem = (props: any) => {
  return <div {...props} />;
};
